// extracted by mini-css-extract-plugin
export default {"gray-30":"rgb(193, 198, 205)","searchIcon":"styles_searchIcon__DfKLY"};